import React from 'react'
import {useTranslations} from 'next-intl'
import {css, useTheme} from '@emotion/react'
import {Divider} from '@mui/material'

import Paper from '../../elements/Paper'
import ToolList from './ToolList'


function SearchPanel({tools, ...props}) {
  const theme = useTheme()
  const styles = {
    root: css`
      padding: 16px;
      background: ${theme.palette.surface.main};
    `,

    header: css`
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 8px;
    `,
  }

  const t = useTranslations()

  return (<Paper css={styles.root} {...props}>
      <div css={styles.header}>{t('tool-layout.search-results')}</div>
      <Divider/>
      <ToolList tools={tools}/>
    </Paper>)
}

export default React.memo(SearchPanel)
